import { render, staticRenderFns } from "./EmailField.form-builder.vue?vue&type=template&id=3b8d4581&"
import script from "./EmailField.form-builder.vue?vue&type=script&lang=js&"
export * from "./EmailField.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports